<template lang="">
    <div class="form-group">
        <label :for="myId" :class="labelWidth">{{ name | capitalize }}</label>
        <div v-if="isRow" :class="inputWidth">
            <check-item ref="checkItem" :type="myType" :d-inline="dInline" :name="name" :value="myValue"
                v-for="(item, index) in options" :key="index" :text="item" :option="item" @input="update"
                @change="update" :disabled="myDisableds[index]">
            </check-item>
        </div>
        <template v-else>
            <check-item ref="checkItem" :type="myType" :d-inline="dInline" :name="name" :value="myValue"
                v-for="(item, index) in options" :key="index" :text="item" :option="item" @input="update"
                @change="update" :disabled="myDisableds[index]">
            </check-item>
        </template>
        <div v-if="isRow" class="col-12">
            <small class="form-text text-danger" v-for="(error, index) in myErrors" :key="index" v-text="error"></small>
        </div>
        <template v-else>
            <small class="form-text text-danger" v-for="(error, index) in myErrors" :key="index" v-text="error"></small>
        </template>
    </div>
</template>
<script>
    import InputBase from './InputBase';
    export default {
        extends: InputBase,
        props: {
            type: {
                default: 'checkbox'
            },
            dInline: {
                default: false
            },
            options: {
                default: undefined
            },
            value: {
                default: undefined
            },
            limit: {
                default: undefined
            }
        },
        watch: {
            value: {
                deep: true,
                handler(newValue, oldValue) {
                    if (this.limit && newValue.length >= this.limit) {
                        this.$refs.checkItem.forEach((item, index) => {
                            this.myDisableds[index] = !newValue.includes(item.option);
                        });
                    } else {
                        this.$refs.checkItem.forEach((item, index) => {
                            this.myDisableds[index] = false;
                        });
                    }
                }
            }
        },
        data() {
            return {
                myValue: undefined,
                myType: undefined,
                myDisableds: []
            };
        },
        mounted() {
            this.myValue = this.value;
            this.myType = ['checkbox', 'radio'].includes(this.type) ? this.type : 'checkbox';
            this.options.forEach((item, index) => this.myDisableds[index] = false);
        },
        methods: {
            update(newValue) {
                this.$emit('input', newValue);
            }
        }
    }
</script>
<style lang="">

</style>